window.product_app = {
    updateImage: (imageEl, newImageSrc) => {
        /* Updates a product images based on variant selection */
        const getImageFilename = (src) => {
            const path = src.split('?v=')[0];
            return path.split('/products/')[1];
        }
        const currentFileName = getImageFilename(imageEl.src);
        const selectedFileName = getImageFilename(newImageSrc);
        imageEl.src = imageEl.src.replace(currentFileName, selectedFileName);
    },
    getCustomVariantDataBySku: (variantSku) => {
        // Note: I needed to use this json from the main-product-custom in order to prevent creating another object of variants with custom properties
        const variantDataFromOffers = JSON.parse(document.getElementById('main-product-json').textContent).offers;
        let variantData = {};
        variantDataFromOffers.some(variant => {
            if (variant.sku === variantSku) {
                variantData = variant;
                return true;
            }
            return false;
        });
        return variantData;
    },
    updateCurrentSelection: (callback) => {
        /* Updates the variant name displayed in multiple places (specifications, size calculator, main pdp) */
        const selectedColorEl = document.querySelector('fieldset.color input:checked');
        const selectedSizeEl = document.querySelector('fieldset.size input:checked')
        const selectedColor = selectedColorEl ? selectedColorEl.value : null;
        const selectedSize = selectedSizeEl ? selectedSizeEl.value : null;
        let currentSelectionText = selectedColor || selectedSize || '';
        if (selectedSize && selectedColor) {
            currentSelectionText = `${selectedColor} / ${selectedSize}`;
        }
        Array.from(document.querySelectorAll('.selected-variant-details .variant-name')).forEach(variantName => variantName.innerText = currentSelectionText);
        if (typeof callback === 'function') {
            callback();
        }
    },
    /**
     * A fix to remove the sticky css when all content will not fit within the height of the window
     * If the all content within product__info-container--sticky does not fit,
     *  subtract the height of each sibling element BEFORE variant-radios (or variant-selects), if the remaining content fits adjust the top position, else just add a class to make the column no longer sticky.
     * Note: The css that makes product__info-container--sticky sticky is not applied for window sizes with a width less than 990px
     */
    stickyProductInfoFix: () => {
        if (window.innerWidth < 990) return;
        const stickyProductInfoEl = document.querySelector('.product__info-container--sticky');
        if (!stickyProductInfoEl) return;
        const stickyProductInfoElStyle = window.getComputedStyle(stickyProductInfoEl);
        const extraSpace = stickyProductInfoElStyle.top ? parseFloat(stickyProductInfoElStyle.top) : 20;
        if ((stickyProductInfoEl.clientHeight + extraSpace) > window.innerHeight) {
            let stickyHeight = stickyProductInfoEl.clientHeight + extraSpace;
            let contentFitsAtVariants;
            stickyProductInfoEl.querySelectorAll(':scope > *').forEach(el => {
                if (contentFitsAtVariants) return;
                if ((el.tagName === 'VARIANT-RADIOS' || el.tagName === 'VARIANT-SELECTS') && stickyHeight < window.innerHeight) {
                    stickyProductInfoEl.style.top = `-${el.offsetTop - extraSpace}px`
                    contentFitsAtVariants = true;
                }
                stickyHeight = stickyHeight - el.clientHeight;
            });
            if (!contentFitsAtVariants) {
                stickyProductInfoEl.classList.add('remove-sticky');
            }
        }
    },
    setMobileStickyAddToCartClass: () => {
        /** Note: I start with the classes on by default to keep the animation of the compare button as desired for our main pdp's **/
        const bodyEl = document.querySelector('body');
        const variantOptionsEl = document.querySelector('variant-radios.no-js-hidden');
        const buyButtonsEl = document.querySelector('.product__info-container .product-form');
        if (!variantOptionsEl) {
            bodyEl.classList.remove('has-variants');
        }
        if (!buyButtonsEl) {
            bodyEl.classList.remove('has-buy-buttons');
        }
    },
    init: () => {
        product_app.stickyProductInfoFix();
        product_app.setMobileStickyAddToCartClass();
    }
};

document.addEventListener('DOMContentLoaded', function() {
    window.product_app.init();
});
